webpackJsonp([3],{

/***/ "/NG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0vzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdatedEftsTable_vue__ = __webpack_require__("Xlu0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_031cf6be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdatedEftsTable_vue__ = __webpack_require__("TOQ9");
function injectStyle (ssrContext) {
  __webpack_require__("q3gK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_UpdatedEftsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_031cf6be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_UpdatedEftsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ceO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7l3X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentConfirmationPrint_vue__ = __webpack_require__("7rP6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_46fe8e12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentConfirmationPrint_vue__ = __webpack_require__("k3mK");
function injectStyle (ssrContext) {
  __webpack_require__("/NG8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentConfirmationPrint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_46fe8e12_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentConfirmationPrint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7rP6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_my_account_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_my_account_common_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PrintHeader_vue__ = __webpack_require__("fn7W");








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentconfirmation',
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a
    };
  },

  methods: {
    getOrdinal: function getOrdinal(nextPayment) {
      if (nextPayment > 3 && nextPayment < 21) return nextPayment + 'th';
      switch (nextPayment % 10) {
        case 1:
          return nextPayment + 'st';
        case 2:
          return nextPayment + 'nd';
        case 3:
          return nextPayment + 'rd';
        default:
          return nextPayment + 'th';
      }
    }
  },
  mounted: function mounted() {},

  computed: {
    eftAgreements: {
      get: function get() {
        var _this = this;

        if (!this.paymentData.eftAgreements.firstName) {
          return [];
        }
        var masterAgreement = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.paymentData.eftAgreements.agreementEFTs, function (agreement) {
          var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
          agreementData.memberName = __WEBPACK_IMPORTED_MODULE_2_my_account_common__["StringUtils"].initCaps(_this.paymentData.eftAgreements.firstName + ' ' + _this.paymentData.eftAgreements.lastName);
          agreementData.mainUser = true;
          agreementData.autoBilled = 'x-' + _this.paymentData.bankInformation.cardNumber;
          agreementData.renewal = _this.getOrdinal(new Date(agreement.renewal).getDate());
          agreementData.accountType = _this.paymentData.bankInformation.cardType;
          agreementData.cardExpirationDate = _this.paymentData.bankInformation.cardExpirationDate;
          agreementData.selected = false;
          return agreementData;
        });
        var faoAgreements = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.paymentData.eftAgreements.memberFaos, function (owner) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(owner.agreementEFTs, function (agreement) {
            var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
            agreementData.memberName = __WEBPACK_IMPORTED_MODULE_2_my_account_common__["StringUtils"].initCaps(owner.firstName + ' ' + owner.lastName);
            agreementData.mainUser = false;
            agreementData.autoBilled = 'x-' + _this.paymentData.bankInformation.cardNumber;
            agreementData.renewal = _this.getOrdinal(new Date(agreement.renewal).getDate());
            agreementData.accountType = _this.paymentData.bankInformation.cardType;
            agreementData.cardExpirationDate = _this.paymentData.bankInformation.cardExpirationDate;
            agreementData.selected = false;
            return agreementData;
          });
        });
        var mappedAgreements = masterAgreement.concat([].concat.apply([], faoAgreements));
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(mappedAgreements, function (agreement) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(_this.paymentData.selectedEftAgreements, agreement.agreementId);
        });
      }
    }
  },
  props: {
    paymentData: {
      type: Object,
      default: {}
    },
    amountPaid: {
      type: String,
      default: ''
    },
    confirmTitle: {
      type: String,
      required: true
    },
    confirmDescription: {
      type: String,
      default: ''
    },
    cardType: {
      type: String,
      default: ''
    },
    htmlTac: {
      type: String,
      default: ''
    },
    previousView: {
      type: String,
      requited: true
    }
  },
  components: {
    'alert-banner': __WEBPACK_IMPORTED_MODULE_3_my_account_common_vue__["AlertBanner"],
    'print-header': __WEBPACK_IMPORTED_MODULE_4__PrintHeader_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "CmG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'printHeader',
  props: ['breadcrumb', 'titleHeader']
});

/***/ }),

/***/ "IZqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hr',{staticClass:"print-only",staticStyle:{"position":"absolute","top":"1px","width":"90%","margin-left":"126px"}}),_vm._v(" "),_c('hr',{staticClass:"print-only",staticStyle:{"position":"absolute","top":"40px","width":"90%","margin-left":"111px"}}),_vm._v(" "),_c('div',{staticClass:"print-only header-margin"},[_c('div',{staticClass:"print-header-logo"},[_c('img',{staticStyle:{"border":"1px solid #ccc","position":"relative","left":"19px"},attrs:{"src":__webpack_require__("dgZd"),"width":"100","height":"70"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.breadcrumb))])])]),_vm._v(" "),_c('div',{staticClass:"title-container"},[_c('h3',{staticClass:"title-24 title-line"},[_vm._v(_vm._s(_vm.titleHeader))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JRq3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24",attrs:{"id":"payment-confirmation"}},[_c('loading',{attrs:{"show":_vm.showSpinner,"label":"Loading...","overlay":true}}),_vm._v(" "),_c('div',{staticClass:"container confirmation-container"},[_c('div',{staticClass:"row confirmation-section"},[_c('section',{staticClass:"col-sm-12 confirmation-desc-header"},[_c('h3',{staticClass:"title-24"},[_vm._v(_vm._s(_vm.confirmTitle))])])])]),_vm._v(" "),_c('div',{staticClass:"container confirmation-container"},[_c('div',{staticClass:"row confirmation-section"},[_c('div',{staticClass:"col-xs-12 col-md-9"},[_c('div',{staticClass:"row edit-form"},[_c('div',{staticClass:"confirmation-about-section col-xs-12",class:_vm.paymentData.agreements && _vm.paymentData.agreements.length ? 'col-sm-6 col-md-5 col-lg-5' : 'col-sm-12'},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Date:")]),_vm._v(" "),_c('p',{class:_vm.paymentData.agreements && _vm.paymentData.agreements.length ? '' : 'no-agreements'},[_vm._v(_vm._s(_vm.moment().format('MM/DD/YYYY')))])])]),_vm._v(" "),(_vm.paymentData.agreements.length)?_c('div',{staticClass:"confirmation-about-section col-xs-12 col-sm-6 col-md-5 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Amount Paid:")]),_vm._v(" "),_c('p',[_vm._v("$"+_vm._s(_vm.amountPaid))])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row edit-form"},[_c('div',{staticClass:"confirmation-about-section col-xs-12",class:_vm.paymentData.agreements && _vm.paymentData.agreements.length ? 'col-sm-6 col-md-5 col-lg-5' : 'col-sm-12',attrs:{"id":"confirmationDescription"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Description:")]),_vm._v(" "),_c('p',{class:_vm.paymentData.agreements && _vm.paymentData.agreements.length ? '' : 'no-agreements'},[_vm._v(_vm._s(_vm.confirmDescription))])])]),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length)?_c('div',{staticClass:"confirmation-about-section col-xs-12 col-sm-6 col-md-5 col-lg-5"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Billed To:")]),_vm._v(" "),_c('p',[(_vm.paymentData.bankInformation.cardType === 'MC')?[_c('i',{staticClass:"cc-sprite mc-cc-color"}),_vm._v("\n                  MasterCard\n                ")]:(_vm.paymentData.bankInformation.cardType === 'VISA')?[_c('i',{staticClass:"cc-sprite visa-cc-color"}),_vm._v("\n                  Visa\n                ")]:(_vm.paymentData.bankInformation.cardType === 'AMX')?[_c('i',{staticClass:"cc-sprite amx-cc-color"}),_vm._v("\n                  American Express\n                ")]:(_vm.paymentData.bankInformation.cardType === 'DIS')?[_c('i',{staticClass:"cc-sprite dis-cc-color"}),_vm._v("\n                  Discover\n                ")]:[_c('i',{staticClass:"fa fa-university fa-lg"})]],2)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 hidden-xs hidden-sm materialized"},[_c('button',{staticClass:"btn btn-default btn-print",attrs:{"id":"billing-print","disabled":_vm.isPrinting},on:{"click":function($event){_vm.printBilling()}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPrinting),expression:"isPrinting"}],staticClass:"fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon"}),_vm._v("\n          Print\n        ")])])])]),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length)?_c('div',{staticClass:"container confirmation-container"},[_vm._m(0,false,false)]):_vm._e(),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length)?_c('div',{staticClass:"container confirmation-container"},[_c('payment-agreements-table',{attrs:{"agreementData":_vm.paymentData}})],1):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',{staticClass:"container confirmation-container"},[_vm._m(1,false,false)]):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',{staticClass:"container confirmation-container"},[_c('updated-efts-table',{attrs:{"agreementData":_vm.paymentData.eftAgreements,"selectedEftAgreements":_vm.paymentData.selectedEftAgreements,"bankInfo":_vm.paymentData.bankInformation}})],1):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',{staticClass:"container confirmation-container"},[_vm._m(2,false,false)]):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',{staticClass:"container confirmation-container terms-title"},[_vm._m(3,false,false)]):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',{staticClass:"container confirmation-container"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-24 terms-and-conditions"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlTac)}})])])]):_vm._e(),_vm._v(" "),_c('payment-confirmation-print',{attrs:{"amountPaid":_vm.amountPaid,"confirmTitle":_vm.confirmTitle,"confirmDescription":_vm.confirmDescription,"cardType":_vm.paymentData.bankInformation.cardType,"paymentData":_vm.paymentData,"htmlTac":_vm.htmlTac,"previousView":_vm.previousView}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card-24"},[_c('div',{staticClass:"card-text-container col-sm-12"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("Please allow 24 hours for your agreement(s) records to be updated.\n            You will also receive a confirmation email of this request you have submitted online.\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card-24"},[_c('div',{staticClass:"card-text-container col-sm-12"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("Your request to update the billing information for monthly dues has been submitted. The following\n            amount(s) (plus applicble tax) will be charged to your account through the ACH, (each an EFT),\n            or recurring charges to your credit card, (RCC), on your next bill date.\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card-24"},[_c('div',{staticClass:"card-text-container col-sm-12"},[_c('div',{staticClass:"text-24"},[_c('p',[_vm._v("NOTE: Requests to update your billing information made within 5 days of your next debit date may\n            not take effect until the following month.\n          ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation-section"},[_c('p',[_c('i',{staticClass:"fa fa-file-text-o"}),_vm._v(" Terms and Conditions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Nq1j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TOQ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row billing-section"},[_c('div',{staticClass:"col-md-12 materialized",attrs:{"id":"updated-efts-table"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.eftAgreements,"styleClass":"table condensed table-hover","sortable":"true"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('td',{staticClass:"text-center",attrs:{"data-title":"Member"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.memberName))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Agreement"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.agreementId))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('(' + props.row.agreementType + ')'))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Next Debit Date"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.renewal))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Method of Payment"}},[(props.row.accountType === 'MC')?[_c('i',{staticClass:"cc-sprite mc-cc-color",class:{'overdue-card' : _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(props.row.accountType === 'VISA')?[_c('i',{staticClass:"cc-sprite visa-cc-color",class:{'overdue-card' : _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(props.row.accountType === 'AMX')?[_c('i',{staticClass:"cc-sprite amx-cc-color",class:{'overdue-card' : _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(props.row.accountType === 'DIS')?[_c('i',{staticClass:"cc-sprite dis-cc-color",class:{'overdue-card' : _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:[_c('i',{staticClass:"fa fa-university fa-lg"})],_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item",class:{'overdue-card' :
          !(props.row.accountType === 'SAV' || props.row.accountType === 'CHK')
          && _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}},[_vm._v("\n            "+_vm._s(props.row.autoBilled)+"\n          ")]),_vm._v(" "),_c('br'),_vm._v(" "),(props.row.cardExpirationDate)?[_c('span',{staticClass:"data-item",class:{'overdue-card' : _vm.moment(props.row.cardExpirationDate, 'MM/YY') < _vm.moment()}},[_vm._v("(Exp. "+_vm._s(props.row.cardExpirationDate)+")")])]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Dues Amount"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('$' + props.row.recurringDues.toFixed(2)))])])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UNGZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentAgreementsTable',
  props: {
    agreementData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      columns: [{
        label: 'Member',
        field: 'memberName',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Agreement',
        field: 'agreementId',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Reference Number',
        field: 'referenceNumber',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Description',
        field: 'description',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Amount Paid',
        field: 'amountPaid',
        tdClass: 'text-center',
        thClass: 'text-center'
      }]
    };
  },

  computed: {
    eftAgreements: {
      get: function get() {
        return this.agreementData.agreements;
      }
    }
  }
});

/***/ }),

/***/ "Xlu0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common__ = __webpack_require__("OrvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_my_account_common__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UpdatedEftsTable',
  props: {
    agreementData: {
      type: Object,
      required: true
    },
    selectedEftAgreements: {
      type: Array,
      required: true
    },
    bankInfo: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      columns: [{
        label: 'Member',
        field: 'memberName',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Agreement',
        field: 'agreementId',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Next Debit Date',
        field: 'renewal',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Method of Payment',
        field: 'autoBilled',
        tdClass: 'text-center',
        thClass: 'text-center'
      }, {
        label: 'Dues Amount',
        field: 'recurringDues',
        tdClass: 'text-center',
        thClass: 'text-center'
      }],
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a
    };
  },

  methods: {
    getOrdinal: function getOrdinal(nextPayment) {
      if (nextPayment > 3 && nextPayment < 21) return nextPayment + 'th';
      switch (nextPayment % 10) {
        case 1:
          return nextPayment + 'st';
        case 2:
          return nextPayment + 'nd';
        case 3:
          return nextPayment + 'rd';
        default:
          return nextPayment + 'th';
      }
    }
  },
  computed: {
    eftAgreements: {
      get: function get() {
        var _this = this;

        if (!this.agreementData.firstName) {
          return [];
        }
        var masterAgreement = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.agreementData.agreementEFTs, function (agreement) {
          var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
          agreementData.memberName = __WEBPACK_IMPORTED_MODULE_2_my_account_common__["StringUtils"].initCaps(_this.agreementData.firstName + ' ' + _this.agreementData.lastName);
          agreementData.mainUser = true;
          agreementData.autoBilled = 'x-' + _this.bankInfo.cardNumber;
          agreementData.renewal = _this.getOrdinal(new Date(agreement.renewal).getDate());
          agreementData.accountType = _this.bankInfo.cardType;
          agreementData.cardExpirationDate = _this.bankInfo.cardExpirationDate;
          agreementData.selected = false;
          return agreementData;
        });
        var faoAgreements = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.agreementData.memberFaos, function (owner) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(owner.agreementEFTs, function (agreement) {
            var agreementData = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(agreement);
            agreementData.memberName = __WEBPACK_IMPORTED_MODULE_2_my_account_common__["StringUtils"].initCaps(owner.firstName + ' ' + owner.lastName);
            agreementData.mainUser = false;
            agreementData.autoBilled = 'x-' + _this.bankInfo.cardNumber;
            agreementData.renewal = _this.getOrdinal(new Date(agreement.renewal).getDate());
            agreementData.accountType = _this.bankInfo.cardType;
            agreementData.cardExpirationDate = _this.bankInfo.cardExpirationDate;
            agreementData.selected = false;
            return agreementData;
          });
        });
        var mappedAgreements = masterAgreement.concat([].concat.apply([], faoAgreements));
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(mappedAgreements, function (agreement) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.includes(_this.selectedEftAgreements, agreement.agreementId);
        });
      }
    }
  }
});

/***/ }),

/***/ "ZqFN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentConfirmation_vue__ = __webpack_require__("u+P1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13dd965a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentConfirmation_vue__ = __webpack_require__("JRq3");
function injectStyle (ssrContext) {
  __webpack_require__("aY2x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13dd965a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentConfirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13dd965a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentConfirmation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aY2x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b51/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row confirmation-section"},[_c('div',{staticClass:"col-md-12 materialized",attrs:{"id":"payment-agreements-table"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.eftAgreements,"styleClass":"table condensed table-hover","sortable":"false"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('td',{staticClass:"text-center",attrs:{"data-title":"Member"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.memberName))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Agreement"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.agreement))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('(' + props.row.agreementDescription + ')'))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Reference Number"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.referenceNumber))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Description"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(props.row.description))])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Amount Paid"}},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('$' + props.row.balance.toFixed(2)))])])]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fn7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrintHeader_vue__ = __webpack_require__("CmG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c176724e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrintHeader_vue__ = __webpack_require__("IZqf");
function injectStyle (ssrContext) {
  __webpack_require__("5ceO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PrintHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c176724e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PrintHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k3mK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-24 section-to-print print-only"},[_c('div',{staticClass:"container billing-container",attrs:{"id":"print-billing-sessions"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('print-header',{attrs:{"breadcrumb":_vm.previousView === 'makeAPayment' ? 'My Billing > Make a Payment' : 'My Billing > Manage AutoPay',"titleHeader":_vm.confirmTitle}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"datas-print"},[_c('span',{staticClass:"label-print"},[_vm._v("Date:")]),_vm._v(" "),_c('span',{staticClass:"data-print"},[_vm._v(_vm._s(_vm.moment().format('MM/DD/YYYY')))])]),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length > 0)?_c('div',{staticClass:"datas-print"},[_c('span',{staticClass:"label-print"},[_vm._v("Amount Paid:")]),_vm._v(" "),_c('span',{staticClass:"data-print"},[_vm._v("$"+_vm._s(_vm.amountPaid))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{class:_vm.paymentData.agreements && _vm.paymentData.agreements.length > 0 ? 'datas-print' : 'datas-print-no-limit-width'},[_c('span',{staticClass:"label-print"},[_vm._v("Description:")]),_vm._v(" "),_c('span',{staticClass:"data-print"},[_vm._v(_vm._s(_vm.confirmDescription))])]),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length > 0)?_c('div',{staticClass:"datas-print"},[_c('span',{staticClass:"label-print"},[_vm._v("Billed To:")]),_vm._v(" "),_c('span',{staticClass:"data-print"},[(_vm.cardType === 'MC')?[_c('i',{staticClass:"fa fa-cc-mastercard fa-lg"}),_vm._v("\n              MasterCard\n            ")]:(_vm.cardType === 'VISA')?[_c('i',{staticClass:"fa fa-cc-visa fa-lg"}),_vm._v("\n              Visa\n            ")]:(_vm.cardType === 'AMX')?[_c('i',{staticClass:"fa fa-cc-amex fa-lg"}),_vm._v("\n              American Express\n            ")]:(_vm.cardType === 'DIS')?[_c('i',{staticClass:"fa fa-cc-discover fa-lg"}),_vm._v("\n              Discover\n            ")]:[_c('i',{staticClass:"fa fa-university fa-lg"})]],2)]):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),(_vm.paymentData.agreements && _vm.paymentData.agreements.length > 0)?_c('div',{staticClass:"row print-table"},[_c('table',{staticClass:"col-md-12 table-main"},[_c('tr',[_c('td',{staticClass:"table-data"},[_c('table',{staticClass:"table"},[_vm._m(1,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.paymentData.agreements),function(row){return _c('tr',[_c('td',[_vm._v(" "+_vm._s(row.memberName)+" ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(row.agreement))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('(' + row.agreementDescription + ')'))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(row.referenceNumber)+" ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(row.description)+" ")]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(" "+_vm._s(row.balance.toFixed(2))+" ")])])}))])])])])]):_vm._e(),_vm._v(" "),(_vm.paymentData.selectedEftAgreements.length)?_c('div',[_vm._m(2,false,false),_vm._v(" "),_c('div',{staticClass:"row print-table"},[_c('table',{staticClass:"col-md-12 table-main"},[_c('tr',[_c('td',{staticClass:"table-data"},[_c('table',{staticClass:"table"},[_vm._m(3,false,false),_vm._v(" "),_c('tbody',_vm._l((_vm.eftAgreements),function(row){return _c('tr',[_c('td',[_vm._v(_vm._s(row.memberName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(row.agreementId))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item"},[_vm._v(_vm._s('(' + row.agreementType + ')'))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"data-item"},[_vm._v(_vm._s(row.renewal))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[(row.accountType === 'MC')?[_c('i',{staticClass:"fa fa-cc-mastercard fa-lg",class:{'overdue-card' : _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(row.accountType === 'VISA')?[_c('i',{staticClass:"fa fa-cc-visa fa-lg",class:{'overdue-card' : _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(row.accountType === 'AMX')?[_c('i',{staticClass:"fa fa-cc-amex fa-lg",class:{'overdue-card' : _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:(row.accountType === 'DIS')?[_c('i',{staticClass:"fa fa-cc-discover fa-lg",class:{'overdue-card' : _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}})]:[_c('i',{staticClass:"fa fa-university fa-lg"})],_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"data-item",class:{'overdue-card' :
          !(row.accountType === 'SAV' || row.accountType === 'CHK')
          && _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}},[_vm._v("\n            "+_vm._s(row.autoBilled)+"\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),(row.cardExpirationDate)?[_c('span',{staticClass:"data-item",class:{'overdue-card' : _vm.moment(row.cardExpirationDate, 'MM/YY') < _vm.moment()}},[_vm._v("(Exp. "+_vm._s(row.cardExpirationDate)+")")])]:_vm._e()],2),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"data-title":"Dues Amount"}},[_c('span',{staticClass:"data-item"},[_vm._v("\n                    "+_vm._s('$' + row.recurringDues.toFixed(2))+"\n                  ")])])])}))])])])])]),_vm._v(" "),_vm._m(4,false,false),_vm._v(" "),_vm._m(5,false,false),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"terms-and-conditions col-md-12"},[_vm._m(6,false,false),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.htmlTac)}})])])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"info"},[_c('p',[_vm._v("Please allow 24 hours for your agreement(s) records to be updated. You will also receive a confirmation email of this request you have submitted online.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"title-cells"},[_vm._v("Member")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Agreement")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Reference Number")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Description")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Amount Paid")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"info"},[_c('p',[_vm._v("Your request to update the billing information for monthly dues has been submitted. The following amount(s) (plus applicable tax) will be charged to your account through the ACH, (each an”EFT”), or recurring charges to your credit card (“RCC”), on your next bill date.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"title-cells"},[_vm._v("Member")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Agreement")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Next Debit Date")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Method of Payment")]),_vm._v(" "),_c('th',{staticClass:"title-cells text-center"},[_vm._v("Dues Amount")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._v("\n          NOTE: Requests to update your billing information made within 5 days of your next debit date may not take effect until the following month.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('hr',{staticClass:"bg-gray"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tac-title"},[_c('i',{staticClass:"fa fa-file-text-o",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"margin-sides-10"},[_vm._v("Terms and Conditions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "q3gK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u+P1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common_vue__ = __webpack_require__("Uu/Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_my_account_common_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_my_account_common_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PaymentAgreementsTable_vue__ = __webpack_require__("vO+d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdatedEftsTable__ = __webpack_require__("0vzB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaymentConfirmationPrint_vue__ = __webpack_require__("7l3X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_CommonBilling__ = __webpack_require__("vGe0");










var paymentUpdateService = __WEBPACK_IMPORTED_MODULE_6_CommonBilling__["a" /* ServiceContainer */].paymentUpdateService;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PaymentConfirmation',
  props: {
    paymentData: {
      type: Object,
      required: true
    },
    confirmTitle: {
      type: String,
      required: true
    },
    confirmDescription: {
      type: String,
      required: true
    },
    previousView: {
      type: String,
      requited: true
    }
  },
  components: {
    PaymentConfirmationPrint: __WEBPACK_IMPORTED_MODULE_5__PaymentConfirmationPrint_vue__["a" /* default */],
    'loading': __WEBPACK_IMPORTED_MODULE_6_CommonBilling__["c" /* loading */],
    'alert-banner': __WEBPACK_IMPORTED_MODULE_2_my_account_common_vue__["AlertBanner"],
    'payment-agreements-table': __WEBPACK_IMPORTED_MODULE_3__PaymentAgreementsTable_vue__["a" /* default */],
    'updated-efts-table': __WEBPACK_IMPORTED_MODULE_4__UpdatedEftsTable__["a" /* default */],
    'payment-confirmation-print': __WEBPACK_IMPORTED_MODULE_5__PaymentConfirmationPrint_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showSpinner: false,
      isPrinting: false,
      moment: __WEBPACK_IMPORTED_MODULE_1_moment___default.a,
      htmlTac: '',
      agreementData: {}
    };
  },

  methods: {
    printBilling: function printBilling() {
      this.isPrinting = !this.isPrinting;
      this.$forceUpdate();
      this.$nextTick(function () {
        window.print();
        this.isPrinting = !this.isPrinting;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    paymentUpdateService.getTacHtml({}).then(function (response) {
      _this.htmlTac = response.data;
    });
  },

  computed: {
    amountPaid: {
      get: function get() {
        var sumAmount = 0;
        __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.map(this.paymentData.agreements, function (agreement) {
          sumAmount += agreement.balance;
        });
        return sumAmount.toFixed(2);
      }
    }
  }
});

/***/ }),

/***/ "vO+d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentAgreementsTable_vue__ = __webpack_require__("UNGZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_82fbafb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentAgreementsTable_vue__ = __webpack_require__("b51/");
function injectStyle (ssrContext) {
  __webpack_require__("Nq1j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_PaymentAgreementsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_82fbafb8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_PaymentAgreementsTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/PaymentConfirmation.js